import React, { useEffect, useState } from "react";
import { getAsmtById } from "../../services/authService";
import { useParams } from "react-router-dom";
import { decodeId } from "../../utills/idUtils";

const ReportStatPart2 = ({ isGeneratingPdf }) => {
  const { encodedId } = useParams();
  const id = decodeId(encodedId);
  const [assessmentType, setAssessmentType] = useState(null); // State to store the assessment type

  useEffect(() => {
    const fetchAsmtType = async () => {
      const asmtData = await getAsmtById(id);
      setAssessmentType(asmtData.assessment_type);
    };

    if (id) {
      fetchAsmtType();
    }
  }, [id]);

  return (
    <>
      {isGeneratingPdf ? (
        <>
          <div className=" grid mx-auto p-3 py-5 lg:px-8 mt-5">
          <div style={{pageBreakAfter:'always'}}>
          </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {[
                {
                  title: "SECTION 1",
                  subtitle: "Element Summary",
                  description:
                    "This section gives you an overall snapshot of your Executive Presence, presenting the average scores across the 7 key elements assessed by your respondents, alongside your self-assessment scores. It serves as a quick reference to identify where you excel and where improvement is needed.",
                  selfDesc:
                    "This section provides an overall snapshot of your Executive Presence, presenting the consolidated scores for the 7 key elements from your self-assessment. It offers a quick reference to identify areas where you excel and where there may be opportunities for improvement.",
                },
                {
                  title: "SECTION 2",
                  subtitle: "Detailed Breakdown by Element",
                  description:
                    "Each element is further explored with a question-by-question breakdown, offering insight into specific behaviors that contribute to your overall score. This helps you pinpoint the precise areas where feedback indicates strengths or challenges.",
                  selfDesc:
                    "Each element is explored in detail with a question-by-question breakdown, providing insights into specific behaviors that contribute to your overall score. This allows you to pinpoint the exact areas where your self-assessment indicates strengths or potential challenges.",
                },
                {
                  title: "SECTION 3",
                  subtitle: "Qualitative Insights",
                  description:
                    "In this section, you’ll find open-ended comments from your respondents. These qualitative insights provide a deeper understanding of how others perceive your executive presence style and behaviors in action.",
                  selfDesc:
                    "In this section, you'll find open-ended comments from your self-assessment. These qualitative insights offer a deeper reflection on how you perceive your own executive presence style and behaviors in action.",
                },
                {
                  title: "SECTION 4",
                  subtitle: "Top Strengths and Areas for Improvement",
                  description:
                    "Based on the quantitative and qualitative feedback, this section highlights your core strengths and the key areas for development. It serves as a guide for personal growth and professional development.",
                  selfDesc:
                    "This section highlights your core strengths and key areas for improvement. It serves as a guide to support your personal growth and professional development.",
                },
              ].map((section, index) => (
                <div
                  style={{
                    fontFamily: "Helvetica",
                    // background: "#e5e7eb",
                  }}
                  key={index}
                  className=" rounded-lg  p-6 flex flex-col justify-center h-full bg-gray-300"
                >
                  <h2
                    className="text-center font-bold text-lg"
                    style={{ fontFamily: "Helvetica" }}
                  >
                    {section.title}
                  </h2>
                  <h3
                    className="text-center font-bold text-md pb-3"
                    style={{ fontFamily: "Helvetica" }}
                  >
                    {section.subtitle}
                  </h3>
                  <p
                    className=" tracking-wide text-justify"
                    style={{ fontFamily: "Helvetica" }}
                  >
                    {assessmentType === "self"
                      ? section.selfDesc
                      : section.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className=" grid mt-5 mx-auto p-5 py-5 lg:px-8" style={{padding:'0 5% 0 5%', fontSize:'15px'}}>
          {/* <div className="mt-5 mx-auto p-5 py-5" style={{ maxWidth: '900px', fontSize: '15px' }}> */}


            <div className="grid grid-cols-1 md:grid-cols-2 gap-3" style={{fontFamily: "Helvetica",  fontSize:'15px'}}
            >
              {[
                {
                  title: "SECTION 1",
                  subtitle: "Element Summary",
                  description:
                    "This section gives you an overall snapshot of your Executive Presence, presenting the average scores across the 7 key elements assessed by your respondents, alongside your self-assessment scores. It serves as a quick reference to identify where you excel and where improvement is needed.",
                  selfDesc:
                    "This section provides an overall snapshot of your Executive Presence, presenting the consolidated scores for the 7 key elements from your self-assessment. It offers a quick reference to identify areas where you excel and where there may be opportunities for improvement.",
                },
                {
                  title: "SECTION 2",
                  subtitle: "Detailed Breakdown by Element",
                  description:
                    "Each element is further explored with a question-by-question breakdown, offering insight into specific behaviors that contribute to your overall score. This helps you pinpoint the precise areas where feedback indicates strengths or challenges.",
                  selfDesc:
                    "Each element is explored in detail with a question-by-question breakdown, providing insights into specific behaviors that contribute to your overall score. This allows you to pinpoint the exact areas where your self-assessment indicates strengths or potential challenges.",
                },
                {
                  title: "SECTION 3",
                  subtitle: "Qualitative Insights",
                  description:
                    "In this section, you’ll find open-ended comments from your respondents. These qualitative insights provide a deeper understanding of how others perceive your executive presence style and behaviors in action.",
                  selfDesc:
                    "In this section, you'll find open-ended comments from your self-assessment. These qualitative insights offer a deeper reflection on how you perceive your own executive presence style and behaviors in action.",
                },
                {
                  title: "SECTION 4",
                  subtitle: "Top Strengths and Areas for Improvement",
                  description:
                    "Based on the quantitative and qualitative feedback, this section highlights your core strengths and the key areas for development. It serves as a guide for personal growth and professional development.",
                  selfDesc:
                    "This section highlights your core strengths and key areas for improvement. It serves as a guide to support your personal growth and professional development.",
                },
              ].map((section, index) => (
                <div
                  style={{
                    fontFamily: "Helvetica",
                    // background: "rgb(245 214 146 / var(--tw-bg-opacity, 1))",
                  }}
                  key={index}
                  className=" rounded-lg  p-6 flex flex-col justify-center h-full bg-gray-300"
                >
                  <h2
                    className="text-center font-bold text-lg"
                    style={{ fontFamily: "Helvetica" }}
                  >
                    {section.title}
                  </h2>
                  <h3
                    className="text-center font-bold text-md pb-3"
                    style={{ fontFamily: "Helvetica" }}
                  >
                    {section.subtitle}
                  </h3>
                  <p
                    className=" tracking-wide text-justify"
                    style={{ fontFamily: "Helvetica" }}
                  >
                    {assessmentType === "self"
                      ? section.selfDesc
                      : section.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ReportStatPart2;
